export default {
    methods: {
        popovers() {
            setTimeout(() => [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"], [popover]')).map(element => new bootstrap.Popover(element, {
                trigger: 'focus',
            })), 300)
        },
    },
}
